module.exports = __webpack_public_path__ + "static/media/checkCircleForStep.6da2ca7f.svg";